<template>
  <router-view></router-view>
</template>
<script setup>
</script>

<style lang="scss">
// #app {
//   width: 100vw;
//   height: 100vh;
// }
// 浏览器也许认为，只有input/textarea中的字体大于等于 16px 时用户才能看得清楚。
// 所以可以通过设置字体大小来阻止页面放大：
input, input:focus,
textarea, textarea:focus,
select, select:focus {
  font-size: 16px !important;
}
</style>
